<div class="p-4 overflow-auto h-[85vh]">
  <div class="flex justify-between -mt-4">
    <h2 class="text-xl font-semibold">Active Directory Configurations</h2>
    <p-button icon="pi pi-plus" label="Add Token" (click)="openAddModal()" class="mb-3"></p-button>
  </div>

  <p-table [value]="tokens" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true" [loading]="loading">
    <ng-template pTemplate="header">
      <tr>
        <th>App Client ID</th>
        <!-- <th>Client Secret</th> -->
        <th>Tenant ID</th>
        <!-- <th>Scope</th> -->
        <th>Redirect URL</th>
        <th>Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-token>
      <tr>
        <td>{{ token.app_client_id }}</td>
        <!-- <td>{{ token.client_secret }}</td> -->
        <td>{{ token.tenant_id }}</td>
        <!-- <td>{{ token.scope }}</td> -->
        <td>{{ token.redirect_uri }}</td>
        <td>
          <div (click)="setTokenData(token)">
            <p-menu #menu appendTo="body" [model]="actionMenuItems" [popup]="true"></p-menu>
            <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h cursor-pointer"></i>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="loading">
      <tr>
        <td colspan="5" class="text-center">
          <p-progressSpinner></p-progressSpinner>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="no-data">
          <p>No Active Directory configurations found</p>
        </td>
      </tr>
    </ng-template>

  </p-table>
</div>

<!-- Create Modal -->
<ng-container *ngIf="displayAddModal">
  <p-dialog [(visible)]="displayAddModal" [modal]="true" [style]="{ width: '50rem' }" [closable]="false">
    <app-create-active-directory [clientId]="clientId" (reload)="reload()"
      (close)="closeAddModal()"></app-create-active-directory>
  </p-dialog>
</ng-container>

<!-- Edit Modal -->
<ng-container *ngIf="showEditModal">
  <p-dialog [(visible)]="showEditModal" [modal]="true" [style]="{ width: '50rem' }" [closable]="false">
    <app-create-active-directory [clientId]="clientId" [type]="'Update'" [activeDirectoryDataToEdit]="tokenDataToEdit"
      (reload)="reload()" (close)="showEditModal = false"></app-create-active-directory>
  </p-dialog>
</ng-container>

<!-- Delete Modal -->
<ng-container *ngIf="showDeleteModal">
  <p-dialog [(visible)]="showDeleteModal" [modal]="true" [style]="{ width: '40rem' }" [closable]="false">
    <app-delete-active-directory-config [activeDirectoryDataToEdit]="tokenDataToEdit" (reload)="reload()"
      (close)="showDeleteModal = false"></app-delete-active-directory-config>
  </p-dialog>
</ng-container>